/**
 * Fitness Fort – Footer newsletter
 * Fixes first-click typing + single-submit via AJAX.
 */
(function () {
  const DEFAULT_SUCCESS = 'Thanks for subscribing!';
  const DEFAULT_ERROR = 'Please enter a valid email address.';

  function getSuccessText(form) {
    const node = form.querySelector('[data-ff-newsletter-success-text]');
    return node?.textContent.trim() || DEFAULT_SUCCESS;
  }

  function hideStaticMessages(form) {
    form.querySelectorAll('.ff-footer__newsletter-error, .ff-footer__newsletter-success').forEach((node) => {
      node.hidden = true;
    });
  }

  function showFeedback(form, type, message) {
    const feedback = form.querySelector('[data-ff-newsletter-feedback]');
    if (!feedback) return;

    hideStaticMessages(form);
    feedback.hidden = false;
    feedback.classList.remove('is-success', 'is-error');
    feedback.classList.add(type === 'success' ? 'is-success' : 'is-error');
    feedback.textContent = message;
    feedback.setAttribute('role', type === 'success' ? 'status' : 'alert');
  }

  function parseResponse(html, form) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const errorNode = doc.querySelector('#FFContactFooter-error, .ff-footer__newsletter-error');
    const successNode = doc.querySelector('#FFContactFooter-success, .ff-footer__newsletter-success');

    if (successNode && successNode.textContent.trim()) {
      return { type: 'success', message: successNode.textContent.trim() };
    }

    if (errorNode && errorNode.textContent.trim()) {
      return { type: 'error', message: errorNode.textContent.trim() };
    }

    if (/already been taken|already subscribed|already exists/i.test(html)) {
      return { type: 'success', message: getSuccessText(form) };
    }

    return { type: 'success', message: getSuccessText(form) };
  }

  async function submitNewsletter(form, input, submit) {
    const email = input.value.trim();
    input.value = email;

    if (!email || !input.checkValidity()) {
      input.reportValidity();
      input.focus();
      return;
    }

    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');

    const body = new URLSearchParams({
      form_type: 'customer',
      utf8: '✓',
      'contact[tags]': 'newsletter',
      'contact[email]': email,
    });

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        headers: {
          Accept: 'text/html',
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: body.toString(),
      });

      const html = await response.text();
      const result = parseResponse(html, form);
      showFeedback(form, result.type, result.message);

      if (result.type === 'success') {
        input.value = email;
        input.setAttribute('aria-invalid', 'false');
      } else {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
    } catch (error) {
      showFeedback(form, 'error', DEFAULT_ERROR);
      input.focus();
    } finally {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  }

  function initNewsletterForm(form) {
    if (!form || form.dataset.ffNewsletterBound === 'true') return;
    form.dataset.ffNewsletterBound = 'true';

    const input = form.querySelector('[data-ff-newsletter-input], [name="contact[email]"]');
    const submit = form.querySelector('[data-ff-newsletter-submit], [type="submit"]');
    if (!input || !submit) return;

    input.addEventListener('pointerdown', (event) => {
      if (document.activeElement !== input) {
        event.preventDefault();
        input.focus({ preventScroll: true });
      }
    });

    input.addEventListener('input', () => {
      input.setAttribute('aria-invalid', 'false');
      const feedback = form.querySelector('[data-ff-newsletter-feedback]');
      if (feedback) feedback.hidden = true;
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submitNewsletter(form, input, submit);
    });
  }

  function init() {
    document.querySelectorAll('.ff-footer__newsletter-form').forEach(initNewsletterForm);
  }

  const DESKTOP_QUERY = window.matchMedia('(min-width: 750px)');

  function syncAccordions() {
    const accordions = document.querySelectorAll('.ff-footer__accordion');
    accordions.forEach((details, index) => {
      details.open = DESKTOP_QUERY.matches ? true : index === 0;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', syncAccordions);
  } else {
    init();
    syncAccordions();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:load', syncAccordions);
  DESKTOP_QUERY.addEventListener('change', syncAccordions);
})();
